export const styles = {
  header: 'tw-flex tw-items-center tw-justify-between tw-mb-3',
  description: 'tw-text-sm tw-text-neutral-500',
  grid: 'tw-grid tw-grid-cols-2 tw-gap-2',
};
